export default {
  hero_title: 'Bine ai revenit!',
  hero_subtitle: 'Ține fața spre soare și umbrele vor rămâne în urmă.',
  title: 'Autentificare în contul personal Estimator24',
  subtitle: 'Introduceți datele pentru a continua.',
  email: 'Adresă de email',
  password: 'Parolă',
  remember_me: 'Ține-mă minte',
  submit: 'Autentificare',
  register_link: 'Creează un cont'
}
